import Notification from '@@types/Notification';

import { isNumber } from 'lodash';
import { action, observable } from 'mobx';
import { mergeLeft } from 'ramda';

class NotificationStore {
  @observable
  notifications = {};

  private closeTimeouts = {};

  @action
  addNotification = (notification: Notification) => {
    const { id, timeout = 5000 } = notification;
    if (this.notifications[id as string]) return;
    const notiWithTimeout = mergeLeft({ timeout })(notification);
    this.notifications[id as string] = notiWithTimeout;
    this.registerCloseTimer(notiWithTimeout);
  };

  @action
  closeNotification = (id: string) => {
    clearTimeout(this.closeTimeouts[id]);
    delete this.closeTimeouts[id];
    this.removeNotification(id);
  };

  @action
  private registerCloseTimer = ({ id, timeout }) => {
    if (!isNumber(timeout) || timeout === 0) return;
    this.closeTimeouts[id as string] = setTimeout(() => this.removeNotification(id), timeout);
  };

  @action
  removeNotification = (id) => {
    delete this.notifications[id];
  };
}

export default NotificationStore;

export const notificationStore = new NotificationStore();
